import { useEffect, useRef, useState } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api, baseURL } from "../../include/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import AdminFooter from "../common/AdminFooter";
import "../../styles/CategoryProductList.css";
import { useNotification } from "../../Toast/ToastProvider";
import { ChevronDown,X } from "react-feather";
import { ERROR, SUCCESS } from "../../include/constant";
import Papa from "papaparse";
import { getAdmin } from "../../include/function";

const ListNotification = () => {
  const navigate = useNavigate();
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [notificationList, setNotificationList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const user = getAdmin();
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig()
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Notification"
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);

  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    customerType: "",
    displayOn: "",
  });

  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;

  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const toast = useNotification();

  const getNotification = (afterGet) => {
    setFetchLoading(true);
    api
      .get("/notification/", adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const allNotifications = response.data.data;
          setNotificationList(allNotifications);
          setFilteredData(allNotifications);
          if (afterGet) afterGet(allNotifications);
        }
      })
      .catch((error) => {
        setNotificationList([]);
        if (afterGet) afterGet([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getNotification();
  }, []);

  useEffect(() => {
    let filtered = [...notificationList];

      filtered = filtered.filter((notif) => notif.source === "manual");

    // Search by title
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((notif) =>
        notif.title?.toLowerCase().startsWith(query)
      );
    }

    // Status filter
    if (filterValues.status) {
      filtered = filtered.filter(
        (notif) => notif.status === filterValues.status
      );
    }

    // Display On filter
    if (filterValues.displayOn) {
      filtered = filtered.filter(
        (notif) => notif.displayOn === filterValues.displayOn
      );
    }

    // Customer Type filter (comma-separated target)
    if (filterValues.customerType) {
      filtered = filtered.filter((notif) => {
        const targetList = (notif.target || "").split(",").map((t) => t.trim());
        return targetList.includes(filterValues.customerType);
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchQuery, filterValues, notificationList,searchParams]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleView = (notificationId) => {
    navigate(
      `/admin/notification/notificationSendNew?id=${notificationId}&view=true`
    );
  };

  const handleEdit = (notificationId) => {
    navigate(`/admin/notification/notificationSendNew?id=${notificationId}`);
  };

  const handleDelete = (notificationId) => {
    if (window.confirm("Are you sure you want to delete this notification?")) {
      api
        .delete(`/notification/?id=${notificationId}`, adminReqConfig())
        .then((response) => {
          if (response) {
            toast({ type: SUCCESS, message: response.data.message });
            setNotificationList((prev) =>
              prev.filter((p) => p.id !== notificationId)
            );
            setFilteredData((prev) =>
              prev.filter((p) => p.id !== notificationId)
            );
          }
        })
        .catch((error) => {
          toast({ type: ERROR, message: "Failed to delete notification" });
          console.error("Delete error:", error);
        });
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedData(currentItems.map((p) => p.id));
    } else {
      setSelectedData((prev) =>
        prev.filter((id) => !currentItems.map((p) => p.id).includes(id))
      );
    }
  };

  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

const handleDownloadCSV = (exportScope = "current") => {
  let dataToExport = [];

  //PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
  if (selectedData.length > 0) {
    dataToExport = notificationList.filter((p) => selectedData.includes(p.id));
  } 
  //PRIORITY 2: If "Export All" clicked → export entire dataset
  else if (exportScope === "all") {
    dataToExport = notificationList;
  } 
  //PRIORITY 3: Default → export current page items only
  else {
    dataToExport = currentItems;
  }

  if (dataToExport.length === 0) {
    toast({ type: "error", message: "No Notification data to download" });
    return;
  }

  const productColumns = [
    "S.No",
    "Name",
    "Display On",
    "Message Body",
    "Customer Type",
    "Image URL",
  ];

  const csvData = dataToExport.map((p, i) => {
    return {
      "S.No": i + 1,
      Name: p.title || "-",
      "Display On": p.display || "-",
      "Message Body": p.body || "",
      "Customer Type": p.target || "-",
      "Image URL": p.imageUrl || "-",
    };
  });

  //CORRECT SYNTAX: fields + data keys (NO parsing error)
  const csv = Papa.unparse({
    fields: productColumns,
    data: csvData.map((row) => productColumns.map((col) => row[col])),
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  
  //Dynamic filename based on export type
  const fileName = selectedData.length > 0 
    ? `Notification_Selected_${selectedData.length}.csv`
    : exportScope === "all" 
      ? "Notification_All.csv" 
      : `Notification_Page${currentPage}.csv`;
    
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const filterWrapperRef = useRef(null);

  const applyFilters = () => {
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    setFilterValues({ status: "", customerType: "", displayOn: "" });
    setIsFilterPanelOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);
  const handleSendNotification = (notificationId) => {
    if (!notificationId) {
      toast({ type: ERROR, message: "Invalid notification ID" });
      return;
    }

    const confirmSend = window.confirm(
      "Are you sure you want to send this notification?"
    );
    if (!confirmSend) return;

    setFetchLoading(true); // Optional: show loading state

    api
      .post(
        `/notification/?id=${notificationId}&flag=sendNotification`,
        {},
        adminReqConfig()
      )
      .then((response) => {
        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: response.data.message || "Notification sent successfully!",
          });
        } else {
          toast({ type: ERROR, message: "Failed to send notification." });
        }
      })
      .catch((error) => {
        console.error("Send notification error:", error);
        toast({
          type: ERROR,
          message: "Error sending notification. Please try again.",
        });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="Send Notification"
      />
      <div
        className="content-wrapper p-0"
        style={{ marginLeft: isSidebarMinimized ? "80px" : "250px", flex: "1" }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
          }}
        >
          {fetchLoading ? (
            <p>Loading Data...</p>
          ) : (
            <>
              <div
                className="ps-22 pe-22 pb-22 rounded-5"
                style={{ backgroundColor: "#fff" }}
              >
                <div className="row align-items-center pt-26 mb-3">
                  <div className="col-auto">
                    <h6 className="mb-0">Notification List</h6>
                  </div>

                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "500px",
                      }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                        {searchQuery && (
                          <X
                            size={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery("");
                              setCurrentPage(1);
                              setIsFilterPanelOpen(false);
                            }}
                            style={{
                              position: "absolute",
                              right: "40px",
                              cursor: "pointer",
                              color: "#999",
                              padding: "4px",
                              zIndex: 10,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.color = "#666")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.color = "#999")
                            }
                          />
                        )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>

                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={(key, value) =>
                            setFilterValues((prev) => ({
                              ...prev,
                              [key]: value,
                            }))
                          }
                          onApply={applyFilters}
                          onClear={clearFilters}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-auto d-flex align-items-center gap-2">
                    {productPermissions.add && (
                      <button
                        className="btn me-0 mb-0"
                        style={{
                          height: "40px",
                          width: "140px",
                          color: "white",
                          backgroundColor: "#2696D5",
                          border: "none",
                          borderRadius: "6px",
                        }}
                        onClick={() =>
                          navigate("/admin/notification/notificationSendNew")
                        }
                      >
                        Add New
                      </button>
                    )}
                    <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                  </div>
                </div>
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Ad Image
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Display On
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Type
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((notification) => (
                          <tr key={notification.id}>
                            <td>
                              <input
                                type="checkbox"
                                style={{ borderColor: "#c5d5f5" }}
                                className="form-check-input"
                                checked={selectedData.includes(notification.id)}
                                onChange={() =>
                                  handleSelectOne(notification.id)
                                }
                              />
                            </td>
                            <td>
                              <div
                                style={{
                                  backgroundColor: "#e9f0f4",
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {notification.imageUrl ? (
                                  <img
                                    src={baseURL + "/" + notification.imageUrl}
                                    alt={notification.title}
                                    style={{
                                      width: "80%",
                                      height: "80%",
                                      objectFit: "contain",
                                      borderRadius: "8px",
                                    }}
                                  />
                                ) : (
                                  <span style={{ fontSize: "24px" }}>🔔</span>
                                )}
                              </div>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {notification.title}
                            </td>
                            <td>
                              {notification.display === "web"
                                ? "Website"
                                : notification.display === "app"
                                  ? "Mobile"
                                  : "All" || ""}
                            </td>
                            <td
                              className="text-capitalize"
                              style={{
                                width: "20%",
                                textWrap: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {notification.target}
                            </td>
                            <td style={{ position: "relative" }}>
                              <div className="d-flex gap-1">
                                {productPermissions.view && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px", // optional
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      color: "inherit",
                                      outline: "none",
                                    }}
                                    onClick={() => handleView(notification.id)}
                                  >
                                    <img
                                      src="/assets/images/view-icon.png"
                                      alt="View"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                  </button>
                                )}
                                {productPermissions.edit && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleEdit(notification.id)}
                                  >
                                    <img
                                      src="/assets/images/edit-icon.png"
                                      alt="Edit"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </button>
                                )}
                                {productPermissions.delete && (
                                  <button
                                    style={{
                                      backgroundColor: "#d9ebff",
                                      height: "39px",
                                      width: "50px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleDelete(notification.id)
                                    }
                                  >
                                    <img
                                      src="/assets/images/delete-icon.png"
                                      alt="Delete"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </button>
                                )}
                                <button
                                  className="btn me-8 mb-3"
                                  style={{
                                    height: "40px",
                                    color: "white",
                                    backgroundColor: "#2696D5",
                                  }}
                                  onClick={() =>
                                    handleSendNotification(notification.id)
                                  }
                                >
                                  Send Notification
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} Lists
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>
    </>
  );
};

export default ListNotification;

//Updated FilterPanel
const FilterPanel = ({ filterValues, onFilterChange, onApply, onClear }) => {
  const customerTypeOptions = [
    { value: "", label: "All Customer Types" },
    { value: "dealer", label: "Dealer" },
    { value: "sub-dealer", label: "Sub-Dealer" },
    { value: "contractor", label: "Contractor" },
    { value: "builder", label: "Builder" },
    { value: "engineer", label: "Engineer" },
    { value: "architect", label: "Architect" },
    { value: "individual", label: "Individual" },
    { value: "others", label: "Others" },
  ];

  const displayOnOptions = [
    { value: "", label: "All" },
    { value: "All", label: "All" },
    { value: "web", label: "Website" },
    { value: "app", label: "Mobile" },
  ];

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "400px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        {/* Customer Type */}
        <div className="col-12">
          <h6 className="fw-bold fs-6 mb-3">Customer Type</h6>
          <select
            className="form-select"
            value={filterValues.customerType || ""}
            onChange={(e) => onFilterChange("customerType", e.target.value)}
          >
            {customerTypeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {/* Display On */}
        <div className="col-12">
          <h6 className="fw-bold fs-6 mb-3">Display On</h6>
          <select
            className="form-select"
            value={filterValues.displayOn || ""}
            onChange={(e) => onFilterChange("displayOn", e.target.value)}
          >
            {displayOnOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="d-flex gap-5 mt-16">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "120px",
            height: "40px",
            border: "none",
          }}
        >
          Apply
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "120px",
            height: "40px",
            border: "none",
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const [isHovered, setIsHovered] = useState(false);
  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];
 const handleSelect = (opt) => {
  setSelected(opt.label);
  setIsOpen(false);
  
  if (opt.value === "export") {
    // ✅ Export = current page only (but selected overrides)
    handleDownloadCSV("current");
  } else if (opt.value === "exportAll") {
    // ✅ Export All = entire dataset (but selected overrides)
    handleDownloadCSV("all");
  }
  setSelected("Options");
};
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
